import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import { IMaskMixin } from 'react-imask';
import { useNavigate } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { ButtonWithLoader } from '../../../components/ui/Buttons';
import { TAuthTabs } from '.';
import { IAppState } from '../../../store/rootDuck';
import { actions as authActions } from '../../../store/ducks/auth.duck';
import { useFormikMfaPassword } from '../hooks/useFormikMfaPassword';
import { useAxiosMfaPassword } from '../hooks/useAxiosMfaPassword';

export const IMaskPhoneInput = IMaskMixin(({ ...props }) => {
  return <TextField {...(props as any)} />;
});

interface IProps {
  changeAuthTab: (newTab: TAuthTabs, props?: any) => void;
  initTab?: number;
}

export const CheckInAuthenticator: React.FC<IProps> = ({
  changeAuthTab,
  initTab,
}) => {
  const [tab, setTab] = useState(initTab);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authToken, checkSuccess } = useSelector(
    ({ auth }: IAppState) => ({
      authToken: auth.authToken,
      mfaData: auth.mfaData,
      checkSuccess: auth.checkSuccess,
    }),
    shallowEqual
  );
  
  // useEffect(() => {
  //   if(mfaData)
  //     alert('MfaCode: ' + mfaData?.mfaCode);
  // }, [mfaData]);
  
  const { makeRequest, loading, res } = useAxiosMfaPassword();
  const formik = useFormikMfaPassword(makeRequest);
  
  // on success
  useEffect(() => {
    if (res) {
      dispatch(authActions.checkMfaSuccess(res));
    }
  }, [res]);

  useEffect(() => {
    if (!checkSuccess) return;
      navigate('/users/buyer');
  }, [checkSuccess])

  useEffect(() => {
    dispatch(authActions.fetchMfaRequest());
  }, []);



  return (
    <div className='kt-login__body'>
      <div className='kt-login__form'>
        <div className='kt-login__title'>
          <h3>Check Authenticator</h3>
        </div>

        <form noValidate autoComplete='off' className='kt-form' onSubmit={formik.handleSubmit}>
          <div className='form-group'>
            <TextField
              variant='outlined'
              type='text'
              margin='normal'
              label='Password'
              className='kt-width-full'
              name='code'
              autoFocus
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.code}
              helperText={formik.touched.code && formik.errors.code}
              error={Boolean(formik.touched.code && formik.errors.code)}
            />
          </div>

          <div
            style={{
              display: 'flex',
              marginTop: 50,
              alignItems: 'center',
            }}
          >
            <div style={{width: '100%'}}>
              <ButtonWithLoader style={{width: '100%'}} onPress={formik.handleSubmit} disabled={loading || (!authToken && tab === 1)} loading={loading}>
                Next
              </ButtonWithLoader>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
